import React, { useState, useEffect } from 'react';
import firebaseService from 'Services/firebaseService';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import Page from 'Components/Page';
import history from '../../history';
import { useForm, Controller } from 'react-hook-form';
import NumberFormat from 'react-number-format';
import * as actions from 'Store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import FormTextField from 'Components/FormTextField';
import Loading from 'Components/Loading';
import * as Regex from '../../regex';
import { isEmpty } from 'lodash';
import Box from '@material-ui/core/Box';
import * as UserHelpers from 'Helpers/user';
import Link from '@material-ui/core/Link';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import usStates from 'Constants/usStates';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const pageStyles = theme => ({
  pageWrapper: {
    paddingLeft: '3%',
    paddingRight: '3%',
  },
  addEditForm: {
    display: 'flex',
    flexDirection: 'column',
  },
  optionalMessage: {
    fontSize: 18,
  },
  button: {
    alignSelf: 'flex-start',
    marginTop: '90px',
  },
  backButton: {
    alignSelf: 'flex-start',
    marginTop: '90px',
    marginRight: '40px',
  },
  photoContainer: {
    marginBottom: '40px',
  },
  selectLabel: {
    top: '-6px',
  },
  selectFormControl: {
    width: '25%',
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    color: 'inherit',
  },
  login: {
    marginTop: '40px',
  },
  proceedButton: {
    color: '#fff',
  },
});

function RegisterProduct({
  classes,
  regCodeId,
  setActiveModal,
  user,
  logoutUser,
  registerWithFirebase,
  registerProductConfigState,
}) {
  let _user = user || {};

  const { register, handleSubmit, errors, getValues, setValue, control } = useForm({
    defaultValues: {
      code: regCodeId || '',
    },
  });

  const [loading, setLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [regProductConfig, setRegProductConfig] = useState(registerProductConfigState);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    (async function () {
      if (regCodeId) {
        try {
          const regCodeData = await firebaseService.getRegistrationCode(regCodeId);

          setRegProductConfig(regCodeData);
        } catch (err) {
          console.warn('Contact server error: ', err);
          return;
        }
      }
    })();

    setValue('phone', user?.phone);
  }, [setValue, regCodeId, user]);

  let { password, confirmPassword } = getValues();

  const openLoginModal = () => {
    setActiveModal('login');
  };

  const onSubmit = async data => {
    setLoading(true);

    //<!-- Event snippet for Website sale conversion page -->
    let { firstName, lastName, email, password, phone } = data;
    let userId;

    // if not logged in then try to register
    // if logged in then submit
    if (!isEmpty(user)) {
      firstName = user.firstName;
      lastName = user.lastName;
      userId = user.uid;
      email = user.email;
    } else {
      try {
        const registrationRequest = await registerWithFirebase({
          email,
          password,
          firstName,
          lastName,
          phone,
        });

        userId = registrationRequest.payload.uid;
      } catch (err) {
        console.warn('Registration error: ', err);
        alert(err);
        return;
      }
    }

    const allData = {
      ...user,
      ...data,
      regCodeId,
      formOwner: regProductConfig.ownerId,
    };

    try {
      console.log('attempting to register::: ', allData);
      await firebaseService.registerProduct(allData);
      setLoading(false);
      setIsComplete(true);
    } catch (err) {
      console.warn('Contact server error: ', err);
      return;
    }
  };

  const tosWindow = () => {
    window.open(`${window.location.origin}/TOS?hasNav=false`, 'tos', 'width=500,height=800');
  };

  function getPhoneHelpertext() {
    if (errors.phone) {
      return errors.phone.message;
    }

    return ``;
  }

  const getCodeHelperText = () => {
    if (errors.code) {
      return errors.code.message;
    }

    return 'Please enter your serial number';
  };

  const getEmailErrorMessage = () => {
    if (errors.email) {
      return errors.email.type === 'isTaken' ? (
        <>
          This email is taken. Please{' '}
          <span className={classes.link} onClick={openLoginModal}>
            (Log in)
          </span>{' '}
          or use another.
        </>
      ) : (
        errors.email.message
      );
    }

    return false;
  };

  const renderUserInformationFields = () => {
    return (
      <div>
        <Typography variant="h5" className={classes.login}>
          Already have an account?{' '}
          <span className={classes.link} onClick={openLoginModal}>
            (Log in here.)
          </span>
        </Typography>

        <FormTextField
          label="First Name"
          name="firstName"
          required
          error={!!errors.firstName}
          helperText={errors.firstName && errors.firstName.message}
          inputRef={register({ required: 'Provide your first name' })}
          placeholder="Enter First Name"
          style={{ marginRight: 20 }}
        />

        <FormTextField
          label="Last Name"
          name="lastName"
          required
          error={!!errors.lastName}
          helperText={errors.lastName && errors.lastName.message}
          inputRef={register({ required: 'Provide your last name' })}
          placeholder="Enter Last Name"
        />

        <Box display="flex">
          <FormTextField
            label="Password"
            name="password"
            type="password"
            required
            error={!!errors.password}
            helperText={errors.password && errors.password.message}
            inputRef={register({
              required: 'Provide your password',
              minLength: {
                value: 8,
                message: 'Password must be longer than 8 characters',
              },
              validate: value => {
                if (confirmPassword && value !== confirmPassword) {
                  return 'Passwords need to match';
                }
              },
            })}
            placeholder="Enter Password"
            style={{ marginRight: 20 }}
          />

          <FormTextField
            label="Confirm"
            name="confirmPassword"
            type="password"
            required
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword && errors.confirmPassword.message}
            inputRef={register({
              required: 'Confirm your password',
              validate: value => {
                if (password && value !== password) {
                  return 'Passwords need to match';
                }
              },
            })}
            placeholder="Enter Password"
          />
        </Box>

        <Box display="flex">
          <FormControl
            control={
              <Checkbox
                name="tosCheckbox"
                className={classes.productCheckbox}
                inputRef={register({
                  required: 'Please agree to the terms of service',
                })}
                required={true}
              />
            }
            label={
              <p>
                I have read and agree to the{' '}
                <Link onClick={tosWindow} target={'tos'}>
                  terms of service
                </Link>
                .
              </p>
            }
            color="primary"
          >
            {errors.tosCheckbox && <FormHelperText>'Please agree to the terms of service'</FormHelperText>}
          </FormControl>
        </Box>
      </div>
    );
  };

  if (isComplete) {
    return (
      <Page wrapperStyles={classes.pageWrapper}>
        <div style={{ marginTop: 50 }}>
          <h1>Success!</h1>
          <p>Your product, is now registered!</p>
          <p>Visit the dashboard to edit your tag information or register another.</p>
          {user && (
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.proceedButton}
              component={Link}
              href="/dashboard"
              style={{ marginTop: 30, textDecoration: 'none' }}
            >
              View registered products
            </Button>
          )}
        </div>
      </Page>
    );
  }

  if (isError) {
    return (
      <Page wrapperStyles={classes.pageWrapper}>
        <div style={{ marginTop: 50 }}>
          <h1>Something went wrong. Please refresh and try again or contact support@ownerfy.com</h1>
          <div>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className={classes.proceedButton}
              component={Link}
              href="/register"
              style={{ marginTop: 30, textDecoration: 'none' }}
            >
              Start Over
            </Button>
          </div>
        </div>
      </Page>
    );
  }

  return (
    <Page wrapperStyles={classes.pageWrapper}>
      {loading ? (
        <Loading
          type={'bubbles'}
          color={'#ccc'}
          height={'80px'}
          width={'80px'}
          containerHeight={'40vh'}
          containerWidth={'100%'}
          message={'Updating...'}
        />
      ) : (
        <>
          <Typography variant="h1">Product Registration {regProductConfig.preview && '(Preview)'}</Typography>
          <FormHelperText>SKU: {regProductConfig.sku}</FormHelperText>
          <FormHelperText>{regProductConfig.introMessage}</FormHelperText>
          <form onSubmit={handleSubmit(onSubmit).bind(this)} className={classes.addEditForm}>
            {regProductConfig.serialNumber && (
              <FormTextField
                fullWidth
                label="Serial Number"
                name="serialNumber"
                inputProps={{
                  maxLength: 20,
                }}
                error={!!errors.code}
                helperText={getCodeHelperText()}
                inputRef={register}
                placeholder=""
              />
            )}

            {regProductConfig.orderNumber && (
              <FormTextField
                fullWidth
                label="Order Number"
                name="orderNumber"
                inputProps={{
                  maxLength: 20,
                }}
                error={!!errors.code}
                helperText={getCodeHelperText()}
                inputRef={register}
                placeholder=""
              />
            )}

            {regProductConfig.purchaseDate && (
              <TextField
                id="date"
                label="Purchase Date"
                type="date"
                name="purchaseDate"
                defaultValue=""
                required={regProductConfig.purchaseDateRequired}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}

            {regProductConfig.purchasePrice && (
              <TextField
                id="purchasePrice"
                name="purchasePrice"
                label="Purchase Price"
                type="number"
                defaultValue=""
                required={regProductConfig.purchasePriceRequired}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}

            {isEmpty(user) && !regProductConfig.preview ? (
              renderUserInformationFields()
            ) : (
              <>
                <Typography variant="h6">
                  Logged in as {_user.firstName}{' '}
                  <span className={classes.link} onClick={logoutUser}>
                    (Log out)
                  </span>
                </Typography>
              </>
            )}

            <FormTextField
              fullWidth
              label="Email"
              name="email"
              required
              error={!!errors.email}
              helperText={getEmailErrorMessage()}
              helperTextComponent="div"
              inputRef={register({
                required: 'Provide the email',
                pattern: {
                  value: Regex.email,
                  message: 'Provide a valid email address',
                },
                validate: {
                  isTaken: async value => {
                    //const isEmailTaken = await debouncedIsEmailTakenMethod(value);
                    const isEmailTaken = await UserHelpers.isEmailTaken(value);
                    if (isEmailTaken) {
                      return 'Email is taken';
                    }
                  },
                },
              })}
              placeholder="Enter Email"
            />

            {regProductConfig.phone && (
              <NumberFormat
                customInput={FormTextField}
                format="###-###-####"
                label="Contact Phone"
                name="phone"
                required={regProductConfig.phoneRequired}
                value={isEmpty(user) ? '' : user.phone}
                error={!!errors.phone}
                helperText={getPhoneHelpertext()}
                inputRef={register}
                placeholder="Enter Phone Number"
              />
            )}

            {regProductConfig.address && (
              <>
                <Typography variant="h5" style={{ marginTop: 100 }}>
                  Address
                </Typography>

                <FormTextField
                  fullWidth
                  label="Address Line 1"
                  name="billingAddressLine1"
                  required={regProductConfig.addressRequired}
                  error={!!errors.billingAddressLine1}
                  helperText={errors.billingAddressLine1 && errors.billingAddressLine1.message}
                  inputRef={register({ required: 'This field is required' })}
                  placeholder="Enter Address Line 1"
                />

                <FormTextField
                  fullWidth
                  label="Address Line 2"
                  name="billingAddressLine2"
                  inputRef={register}
                  placeholder="Enter Address Line 2"
                />

                <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
                  <FormTextField
                    label="City"
                    name="billingCity"
                    required
                    error={!!errors.billingCity}
                    helperText={errors.billingCity && errors.billingCity.message}
                    inputRef={register({ required: 'This field is required' })}
                    placeholder="Enter City"
                    style={{ marginRight: 20 }}
                  />

                  <FormControl className={classes.selectFormControl} error={!!errors.billingState}>
                    <InputLabel id="billing-state-label" className={classes.selectLabel}>
                      State
                    </InputLabel>

                    <Controller
                      as={
                        <Select defaultValue="">
                          {usStates.map(stateName => (
                            <MenuItem value={stateName} key={stateName}>
                              {stateName}
                            </MenuItem>
                          ))}
                        </Select>
                      }
                      required={regProductConfig.addressRequired}
                      name="state"
                      rules={{ required: 'This field is required' }}
                      control={control}
                      labelId="state-label"
                    />

                    {errors.billingState && <FormHelperText>{errors.billingState.message}</FormHelperText>}
                  </FormControl>
                </Box>

                <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
                  <FormTextField
                    label="Zip Code"
                    name="zipCode"
                    required={regProductConfig.addressRequired}
                    error={!!errors.zipCode}
                    helperText={errors.zipCode && errors.zipCode.message}
                    inputRef={register({ required: 'This field is required' })}
                    placeholder="Enter Zip Code"
                    style={{ marginRight: 20 }}
                  />

                  <FormControl className={classes.selectFormControl} error={!!errors.billingCountry}>
                    <InputLabel id="billing-country-label" className={classes.selectLabel}>
                      Country
                    </InputLabel>

                    <Controller
                      as={
                        <Select defaultValue="US">
                          <MenuItem value="US">United States</MenuItem>
                        </Select>
                      }
                      name="country"
                      control={control}
                      labelId="billing-country-label"
                    />

                    {errors.billingCountry && <FormHelperText>{errors.billingCountry.message}</FormHelperText>}
                  </FormControl>
                </Box>
              </>
            )}

            <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
              {regProductConfig.preview ? (
                <Button
                  onClick={() => {
                    history.push('/product-registration/add-code');
                  }}
                  variant="contained"
                  color="primary"
                  className={classes.backButton}
                >
                  Back to Edit
                </Button>
              ) : (
                <Button type="submit" variant="contained" color="primary" className={classes.button}>
                  Submit
                </Button>
              )}
            </Box>
          </form>
        </>
      )}
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      registerWithFirebase: actions.registerWithFirebase,
      setActiveModal: actions.setActiveModal,
      logoutUser: actions.logoutUser,
    },
    dispatch,
  );
}

function mapStateToProps({ user, registerProductConfig }, ownProps) {
  return {
    user,
    registerProductConfigState: registerProductConfig,
    regCodeId: ownProps.match.params.id,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(RegisterProduct)));
